export default {"src":"/_next/static/image/public/img/canva-logo.4e6598e300f0a848a64a1c2ed06766e8.svg","height":98,"width":305};